import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog'
import { LoginForm } from './login-form'

export function LoginDialog({ open }: { open: boolean }) {
  return (
    <Dialog open={open}>
      <DialogContent onEscapeKeyDown={(event) => event.preventDefault()} onInteractOutside={(event) => event.preventDefault()} className="sm:max-w-md [&>button]:hidden">
        <DialogTitle>Logga in · Loco köksskärm</DialogTitle>
        <DialogDescription>Logga in för att öppna denna skärm.</DialogDescription>
        <LoginForm />
      </DialogContent>
    </Dialog>
  )
}
